{
  "version": 1,
  "asset_id": "d3ddefbc-c459-4d7e-8438-47cb6f6d1dd5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d3ddefbc-c459-4d7e-8438-47cb6f6d1dd5/destination-roofing-crew-citrus-county-fl-768.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d3ddefbc-c459-4d7e-8438-47cb6f6d1dd5/destination-roofing-crew-citrus-county-fl-768.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-768.webp",
  "size": 58700,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
